<div class="p-grid instruction">
  <div *ngIf="showHeading" class="p-col-fixed p-d-flex p-pr-0 p-justify-end">
    <em class="pi pi-info-circle p-mt-2" style="font-size: 1.5em"></em>
  </div>
  <div class="p-col">
    <h4 *ngIf="showHeading" class="p-my-2" role="heading" tabindex="0">{{ heading | transloco }}</h4>
    <p class="p-my-2" role="note" tabindex="0" [innerHTML]="note | transloco"></p>
    <ng-content></ng-content>
  </div>
</div>
